/* =============================================================================
   Stambolian - filter drawer, revision of September 30, 2026.
   Runs beside stbl-filter-drawer.js. Adds color cues for the new Metal and
   Stone names, opens only the first group by default and remembers which
   groups are open while filters re-render, and shows the chosen option beside
   each group name.
   ============================================================================= */
(function () {
  'use strict';
  if (window.__stblFilter2) return;
  window.__stblFilter2 = true;

  var TONES = {
    'Two-Tone': 'linear-gradient(90deg,#dfbe6c 50%,#e4e6e8 50%)',
    'Tri-Color': 'linear-gradient(90deg,#dfbe6c 33%,#e4e6e8 33%,#e4e6e8 66%,#dfa893 66%)',
    'Agate': '#e8e4dc',
    'Chalcedony': '#b9c7d6',
    'Carnelian': '#b5482a',
    'Kyanite': '#3f6fae'
  };
  var NO_DOT = { 'Enamel': true };
  var open = null;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function ownText(el) {
    var t = '';
    Array.prototype.forEach.call(el.childNodes, function (n) { if (n.nodeType === 3) t += n.textContent; });
    return clean(t);
  }
  function headings(sidebar) {
    return Array.prototype.filter.call(sidebar.querySelectorAll('.sidebarBlock-heading'), function (h) {
      return !h.closest('.refined-widgets');
    });
  }
  function groupName(h) {
    var t = h.querySelector('.facets__text');
    return clean(t ? t.textContent : ownText(h)).toLowerCase();
  }

  function cues(sidebar) {
    sidebar.querySelectorAll('.facets__list .list-menu__item .facet-checkbox').forEach(function (label) {
      var key = ownText(label);
      if (NO_DOT[key]) { label.classList.add('stbl-no-dot'); return; }
      if (!TONES[key] || label.querySelector('.stbl-stone-dot')) return;
      var dot = document.createElement('span');
      dot.className = 'stbl-stone-dot';
      dot.setAttribute('aria-hidden', 'true');
      dot.style.setProperty('--stone-tone', TONES[key]);
      label.insertBefore(dot, label.firstChild);
    });
  }

  function applyOpen(sidebar) {
    var hs = headings(sidebar);
    if (!hs.length) return;
    if (open === null) { open = {}; open[groupName(hs[0])] = true; }
    hs.forEach(function (h) {
      var want = !!open[groupName(h)];
      if (h.classList.contains('is-clicked') !== want) h.classList.toggle('is-clicked', want);
    });
  }

  function summaries(sidebar) {
    headings(sidebar).forEach(function (h) {
      var block = h.closest('.sidebarBlock');
      if (!block) return;
      var names = [];
      block.querySelectorAll('.facets__list .list-menu__item input:checked').forEach(function (input) {
        var item = input.closest('.list-menu__item');
        var label = item && item.querySelector('.facet-checkbox');
        if (label) names.push(ownText(label));
      });
      var txt = names.length === 0 ? '' : (names.length === 1 ? names[0] : names.length + ' selected');
      var s = h.querySelector('.stbl-group-summary');
      if (!txt) { if (s && s.textContent) s.textContent = ''; return; }
      if (!s) { s = document.createElement('span'); s.className = 'stbl-group-summary'; h.appendChild(s); }
      if (s.textContent !== txt) s.textContent = txt;
    });
  }

  ready(function () {
    if (!document.querySelector('.collection-default')) return;
    var sidebar = document.getElementById('halo-sidebar');
    if (!sidebar) return;

    function run() { cues(sidebar); applyOpen(sidebar); summaries(sidebar); }
    var pending = null;
    function schedule() {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 140);
    }

    sidebar.addEventListener('click', function (e) {
      var h = e.target.closest ? e.target.closest('.sidebarBlock-heading') : null;
      if (!h || h.closest('.refined-widgets')) return;
      if (open === null) open = {};
      var name = groupName(h);
      open[name] = !open[name];
      setTimeout(function () { applyOpen(sidebar); }, 0);
      setTimeout(function () { applyOpen(sidebar); }, 420);
    });

    var form = sidebar.querySelector('#CollectionFiltersForm') || sidebar;
    new MutationObserver(schedule).observe(form, { childList: true, subtree: true });
    form.addEventListener('change', function () { setTimeout(function () { summaries(sidebar); }, 0); });
    run();
  });
})();
